// extracted by mini-css-extract-plugin
export var main = "TabBar-module--main--e0fff";